<template>
  <v-col align="center">
    <v-card width="1000">
      <v-card-title>
        <ProductCardHeader :product-id="product.id" />
      </v-card-title>
      <v-card-text style="color: #4F4F4F">
        <ProductCardSubscriptionRow :is-subscribed="isSubscribed" :name="product.name" />
        <v-container class="pa-0 text-left">
          <div style="text-align: start" class="pb-3">
            HawkSoft E-Signature (powered by Formstack Sign) allows your agency to get documents signed, stored, and logged to the right client file in HawkSoft with ease. Securely send documents for digital signature, track the status, and receive notifications of completed signatures.
          </div>
          <ul class="pb-3">
            <li style="text-align: start">Get documents signed faster</li>
            <li style="text-align: start">Eliminate the need for paper, handling, and filing errors</li>
            <li style="text-align: start">Cover E&O exposure with a digital record</li>
            <li style="text-align: start">Consolidate the storage of all communication and documents into a single system</li>
          </ul>
          <div style="text-align: start">Your agency’s clients can sign documents from their mobile phone, tablet, or computer. This saves your clients the hassle and time of printing, signing, scanning, and emailing paperwork.</div>
        </v-container>
        <v-row class="pa-3">
          <div style="text-align: start; color: #004C97" class="title">
            Pricing
          </div>
        </v-row>
        <v-row class="pl-5">
          <div style="text-align: start">
            ${{ product.productPricing.unitPrice }} {{ product.productPricing.unitDescription }} {{ product.productPricing.unitBillingInterval }}
            (unique email address)
          </div>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-row justify="end" align="center">
          <v-col cols="4" class="font-italic text-center body-2">
            Requires HawkSoft CMS version 4.3 or newer
          </v-col>
          <v-col cols="4">
            <v-btn v-if="!isSubscribed" color="#FF9E15" @click="enableProduct()">Enable {{ product.name }}</v-btn>
            <v-btn v-else color="#FF9E15" @click="enableProduct()">Manage Subscription</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-footer>
        <v-col class="text-center" cols="12">
          <div>
            <a target="_blank" href="https://help.hawksoft.com/webhelp/currenthso/Content/Client_and_Policy_Documents/E-Signature/Purchasing_HawkSoft_E-Signature__Powered_by_Formstack.htm">
              Visit this webpage for step-by-step purchase instructions
            </a>
          </div>
        </v-col>
      </v-footer>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters } from 'vuex';
import ProductCardHeader from '@/components/products/shared/ProductCardHeader';
import ProductCardSubscriptionRow from '@/components/products/shared/ProductCardSubscriptionRow';
import productIdMappingMixin from '@/mixins/productIdMappingMixin';

export default {
  name: 'ESignatureLandingPage',
  components: {
    ProductCardHeader,
    ProductCardSubscriptionRow
  },
  mixins: [productIdMappingMixin],
  computed: {
    ...mapGetters(['getProductByProductId']),
    product () {
      return this.getProductByProductId(this.getProductId('eSignature'));
    },
    isSubscribed () {
      if (this.product) {
        return this.product.isSubscribed;
      }
      return false;
    },
    isEnabled () {
      if (this.product) {
        return this.product.enabled;
      }
      return false;
    }
  },
  methods: {
    async enableProduct () {
      if (this.product.subscribed) {
        this.$router.push('/product/eSignature/userSelection');
      }
      this.$router.push('/product/eSignature/agencyConfirmation');
    }
  }
};

</script>
